import React, { useState } from "react"
import styled from "styled-components"

import { PrimaryButton, TextField } from "shared/components"
import { LARGE_SCREEN_MEDIA_QUERY, SMALL_SCREEN_MEDIA_QUERY } from "shared/helpers/responsive_helpers"
import FormWithImageImageLg from "../images/form-with-image-image-lg.jpg"
import FormWithImageImageSm from "../images/form-with-image-image-sm.jpg"
import { PRIMARY_COLOR_100, WHITE_COLOR } from "../styles"
import { Title2LG } from "./typography"


const ContactForm = styled.form`
  display: grid;
  grid-template-areas:
    "name"
    "email"
    "phone"
    "subject"
    "message"
    "submit";
  grid-template-columns: 1fr;
  grid-template-rows: auto;

  @media ${ SMALL_SCREEN_MEDIA_QUERY} {
    grid-gap: 2rem;
    grid-template-areas:
      "name email"
      "phone subject"
      "message message"
      "submit .";
    grid-template-columns: 1fr 1fr;

  }
`

const NameField = styled.div`
  grid-area: name;
`

const EmailField = styled.div`
  grid-area: email;
`

const PhoneField = styled.div`
  grid-area: phone;
`

const SubjectField = styled.div`
  grid-area: subject;
`

const MessageField = styled.div`
  grid-area: message;
`

const SubmitField = styled.div`
  grid-area: submit;
`

const FormWithImageImage = styled.div`
  background-image: url( ${ FormWithImageImageSm } );
  background-position: center;
  background-repeat: no-repeat;
  background-size:  cover;

  @media ${ LARGE_SCREEN_MEDIA_QUERY } {
    background-image: url( ${ FormWithImageImageLg } );
  }
`

export const FormWithImage = () => {

  const [name, setName] = useState( "" )
  const [email, setEmail] = useState( "" )
  const [phone, setPhone] = useState( "" )
  const [subject, setSubject] = useState( "" )
  const [message, setMessage] = useState( "" )
  const [formSubmitted, setFormSubmitted] = useState( false )
  const [errorMessage, setErrorMessage] = useState<null | string>( null )

  const handleSubmit = ( event: React.FormEvent<HTMLFormElement> ) => {
    event.preventDefault()

    fetch( "https://submit-form.com/nq7-F8iFREJVaRws7qSZ0", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify( {
        "Name": name,
        "Email": email,
        "Phone": phone,
        "Subject": subject,
        "Message": message
      } )
    } )
      .then( () => setFormSubmitted( true ) )
      .catch( () => setErrorMessage( "Sorry, an unknown error occurred" ) )
  }

  return (
    // tslint:disable-next-line: jsx-wrap-multiline
    <div className="flex flex-col lg:flex-row">
      <FormWithImageImage className="lg:w-1/2 flex justify-center lg:justify-end h-screen lg:h-auto p-20">
        <Title2LG className="text-primary-100 text-center">{ `Need Help?!!` }<br />{ `Don't hesitate to ask` }</Title2LG>
      </FormWithImageImage>
      <div className="lg:w-1/2 py-20 px-4 lg:px-20 bg-primary-100">
        <Title2LG className="text-white mb-8">Write To Us!</Title2LG>
        <ContactForm onSubmit={ handleSubmit }>
          { formSubmitted ? (
            errorMessage ? (
              <div className="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4">
                { errorMessage }
              </div>
            ) : (
                <div className="bg-teal-100 border-l-4 border-teal-500 text-teal-700 p-4 my-6">
                  Thanks for getting in touch! We will get back to you shortly.
                </div>
              )
          ) : (
              <>
                <NameField>
                  <TextField
                    inputStyle="line"
                    inputStyleColor={ WHITE_COLOR }
                    label="Name"
                    name="name"
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={ ( e ) => setName( e.target.value ) }
                    placeholder="Name"
                    value={ name }
                    required={ true }
                    labelStyle={ {
                      position: "absolute",
                      overflow: "hidden",
                      clip: "rect(0 0 0 0)",
                      height: "1px",
                      width: "1px",
                      margin: "-1px",
                      padding: "0",
                      border: "0"
                    } }
                  />
                </NameField>

                <EmailField>
                  <TextField
                    inputStyle="line"
                    inputStyleColor={ WHITE_COLOR }
                    label="Email"
                    name="email"
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={ ( e ) => setEmail( e.target.value ) }
                    placeholder="Email"
                    value={ email }
                    type="email"
                    required={ true }
                    labelStyle={ {
                      position: "absolute",
                      overflow: "hidden",
                      clip: "rect(0 0 0 0)",
                      height: "1px",
                      width: "1px",
                      margin: "-1px",
                      padding: "0",
                      border: "0"
                    } }
                  />
                </EmailField>

                <PhoneField>
                  <TextField
                    inputStyle="line"
                    inputStyleColor={ WHITE_COLOR }
                    label="Phone Number"
                    name="phoneNumber"
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={ ( e ) => setPhone( e.target.value ) }
                    placeholder="Phone Number"
                    value={ phone }
                    type="text"
                    required={ true }
                    labelStyle={ {
                      position: "absolute",
                      overflow: "hidden",
                      clip: "rect(0 0 0 0)",
                      height: "1px",
                      width: "1px",
                      margin: "-1px",
                      padding: "0",
                      border: "0"
                    } }
                  />
                </PhoneField>

                <SubjectField>
                  <TextField
                    inputStyle="line"
                    inputStyleColor={ WHITE_COLOR }
                    label="Subject"
                    name="subject"
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={ ( e ) => setSubject( e.target.value ) }
                    placeholder="Subject"
                    value={ subject }
                    type="text"
                    required={ true }
                    labelStyle={ {
                      position: "absolute",
                      overflow: "hidden",
                      clip: "rect(0 0 0 0)",
                      height: "1px",
                      width: "1px",
                      margin: "-1px",
                      padding: "0",
                      border: "0"
                    } }
                  />
                </SubjectField>

                <MessageField>
                  <TextField
                    inputStyle="line"
                    inputStyleColor={ WHITE_COLOR }
                    label="Message"
                    multiline={ true }
                    name="message"
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={ ( e ) => setMessage( e.target.value ) }
                    placeholder="Message"
                    rows="6"
                    value={ message }
                    labelStyle={ {
                      position: "absolute",
                      overflow: "hidden",
                      clip: "rect(0 0 0 0)",
                      height: "1px",
                      width: "1px",
                      margin: "-1px",
                      padding: "0",
                      border: "0"
                    } }
                  />
                </MessageField>

                <SubmitField>
                  <PrimaryButton
                    type="submit"
                    color={ WHITE_COLOR }
                    colorHover={ PRIMARY_COLOR_100 }
                    borderColorHover={ WHITE_COLOR }
                    textColor={ PRIMARY_COLOR_100 }
                    textColorHover={ WHITE_COLOR }
                    className="rounded-full"
                  >
                    Send Message
                  </PrimaryButton>
                </SubmitField>
              </>
            ) }
        </ContactForm>
      </div>
    </div>
  )
}
